import React from "react";
import MembersListView from "components/directory/members/MemberListView";
import TixxtPageTitle from "components/layout/TixxtPageTitle";
import TixxtGroupNavigation from "components/layout/TixxtGroupNavigation";

export default function GroupMembersPage() {
  return (
    <>
      <TixxtPageTitle />
      <TixxtGroupNavigation />
      <MembersListView />
    </>
  );
}
